'use es6';

// Publically consumable contexts, to be added to on an as-needed basis.
import { usePermissionsContext } from '../universal/context/PermissionsContext';
export default usePermissionsContext;